







































































import { Component } from 'vue-property-decorator';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductDetails from '@/components/Products/Product/ProductDetails.vue';
import ProductAccounts from '@/components/Products/Product/ProductAccounts.vue';
import ProductSettingsTabs from '@/components/Products/ProductSettings/ProductSettingsTabs.vue';
import ProductIssues from '@/components/Products/Product/ProductIssues.vue';
import ProductGeneralLedgerMapping from '@/components/Products/Product/ProductGeneralLedgerMapping.vue';
import ProductFees from '@/components/Products/Product/ProductFees.vue';
import History from '@/components/Shared/History.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'Product', components: { Alert, ProductDetails, ProductAccounts, ProductFees, ProductSettingsTabs, ProductIssues, ProductGeneralLedgerMapping, History }, metaInfo: { title: 'Products' } })
export default class extends SaascadaVue {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        ProductDetailsModule.cleanState();
        await ProductDetailsModule.getProduct(this.$route.params.id);
        await ProductDetailsModule.getGeneralLedgerMappings(this.$route.params.id);
        await ProductDetailsModule.getGeneralLedgerMappingOverrides(this.$route.params.id);
    }

    get product() {
        return ProductDetailsModule.product;
    }

    get loading() {
        return ProductDetailsModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
